export default __webpack_public_path__ + "a0844f5.png";